<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<h1>{{appName}}</h1>
			<QueryCondition @query="query" ref="queryCondition" />
			
			<TableFuncs>
				<Button type="primary" icon="ios-add-circle-outline" @click="addShow">新增广告</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button v-if="row.status==1" type="warning" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,0)">停用</Button>
					<Button v-if="row.status==0" type="success" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,1)">启用</Button>
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<!-- <Button type="success" size="small" style="margin-right: 5px"
						@click="copyData(row.id)">复制广告</Button> -->
					<Button type="error" size="small" style="margin-right: 5px" @click="delData(row.id)">删除</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Drawer width="86" :title="addForm.id?'编辑广告':'新增广告'" v-model="addStoreShow" @on-close="initAddData">

			<Form v-model="addForm" :label-width="120" style="padding-bottom:100px;">
				<FormItem label="广告名称" style="width: 600px;" prop="advertName">
					<Input v-model="addForm.advertName" placeholder="请填写广告名称" />
				</FormItem>
				<FormItem label="投放渠道" style="width: 600px;" prop="appStoreId">
					<Select v-model="addForm.appStoreId" @on-change="chooseChannel" placeholder="请选择投放渠道">
						<Option v-for="item in appStores" :value="item.id" :key="item.id">{{item.storeName}}</Option>
					</Select>
				</FormItem>
				<template v-if="addForm.appStoreId">
					<FormItem label="开屏广告" prop="splashIds">
						<Card>
							<Row slot="title">
								<Col span="9" class="col">
								<div style="width: 100px;">选择广告：</div>
								<Select v-model="addForm.splash.splashIds" multiple placeholder="请选择广告"
									@on-change="chooseAdvert($event,'splash')">
									<Option v-for="item in addForm.splashAdverts" :value="item.id" :key="item.id">
										{{item.advertName}}
									</Option>
								</Select>
								</Col>
								<Col span="8" class="col">
								<div style="width: 100px;">延时时间：</div>
								<Input type="number" v-model="addForm.splash.intervalTime" placeholder="请填写延时时间" />ms
								</Col>
								<Col span="7" class="col">
								<div style="width: 100px;">显示次数：</div>
								<Input type="number" v-model="addForm.splash.showNum" placeholder="请填写显示次数" />
								</Col>
							</Row>
							<Table border v-if="addForm.splash.splashIds.length>0" :columns="advertCols"
								:data="addForm.splash.adList">
								<template slot-scope="{ row, index }" slot="sortNum">
									<Input type="number" v-model="row.sortNum"
										@on-change="setRowData($event,row,'splash')" placeholder="请填写优先级" />
								</template>
							</Table>
						</Card>
					</FormItem>
					<FormItem label="插屏广告" prop="tableIds">
						<Card>
							<Row slot="title">
								<Col span="9" class="col">
								<div style="width: 100px;">选择广告：</div>
								<Select v-model="addForm.table.tableIds" multiple placeholder="请选择广告"
									@on-change="chooseAdvert($event,'table')">
									<Option v-for="item in addForm.tableAdverts" :value="item.id" :key="item.id">
										{{item.advertName}}
									</Option>
								</Select>
								</Col>
								<Col span="8" class="col">
								<div style="width: 100px;">延时时间：</div>
								<Input type="number" v-model="addForm.table.intervalTime" placeholder="请填写延时时间" />ms
								</Col>
								<Col span="7" class="col">
								<div style="width: 100px;">显示次数：</div>
								<Input type="number" v-model="addForm.table.showNum" placeholder="请填写显示次数" />
								</Col>
							</Row>
							<Table border v-if="addForm.table.tableIds.length>0" :columns="advertCols"
								:data="addForm.table.adList">
								<template slot-scope="{ row, index }" slot="sortNum">
									<Input type="number" v-model="row.sortNum"
										@on-change="setRowData($event,row,'table')" placeholder="请填写优先级" />
								</template>
							</Table>
						</Card>
					</FormItem>
					<FormItem label="信息流广告" prop="template">
						<Card>
							<Row slot="title">
								<Button type="primary" @click="addChildAdvert('template')">添加信息流广告</Button>
							</Row>
							<Card v-for="(item,index) in addForm.template" :key="item.id">
								<Row slot="title">
									<Col span="9" class="col">
									<div style="width: 100px;">选择广告：</div>
									<Select v-model="item.templateIds" multiple placeholder="请选择广告"
										@on-change="chooseAdvert($event,'template',item)">
										<Option v-for="item in addForm.templateAdverts" :value="item.id" :key="item.id">
											{{item.advertName}}
										</Option>
									</Select>
									</Col>
									<Col span="8" class="col">
									<div style="width: 100px;">位置编码：</div>
									<Input v-model="item.position" placeholder="请填写位置编码" />
									</Col>
									<Col span="7" class="col">
									<div style="width: 100px;">显示次数：</div>
									<Input type="number" v-model="item.showNum" placeholder="请填写显示次数" />
									</Col>
								</Row>
								<Table border v-if="item.templateIds.length>0" :columns="advertCols"
									:data="item.adList">
									<template slot-scope="{ row, index }" slot="sortNum">
										<Input type="number" v-model="row.sortNum"
											@on-change="setRowData($event,row,'template')" placeholder="请填写优先级" />
									</template>
								</Table>
							</Card>
						</Card>

					</FormItem>
					<FormItem label="自有广告" prop="inner">
						<Card>
							<Row slot="title">
								<Button type="primary" @click="addChildAdvert('inner')">添加自有广告</Button>
							</Row>
							<Card v-for="(item,index) in addForm.inner" :key="item.id">
								<Row slot="title">
									<Col span="9" class="col">
									<div style="width: 100px;">选择广告：</div>
									<Select v-model="item.innerIds" multiple placeholder="请选择广告"
										@on-change="chooseAdvert($event,'inner',item)">
										<Option v-for="item in addForm.innerAdverts" :value="item.id" :key="item.id">
											{{item.advertName}}
										</Option>
									</Select>
									</Col>
									<Col span="8" class="col">
									<div style="width: 100px;">位置编码：</div>
									<Input v-model="item.position" placeholder="请填写位置编码" />
									</Col>
									<Col span="7" class="col">
									<div style="width: 100px;">显示次数：</div>
									<Input type="number" v-model="item.showNum" placeholder="请填写现实次数" />
									</Col>
								</Row>
								<Table border v-if="item.innerIds.length>0" :columns="advertCols" :data="item.adList">
									<template slot-scope="{ row, index }" slot="sortNum">
										<Input type="number" v-model="row.sortNum"
											@on-change="setRowData($event,row,'inner')" placeholder="请填写优先级" />
									</template>
								</Table>
							</Card>
						</Card>
					</FormItem>
					<FormItem class="bt">
						<Button type="default" @click="initAddData" style="margin-right: 40px;">取消新增</Button>
						<Button type="primary" @click="addOrUpdateData">确认提交</Button>
					</FormItem>
				</template>

			</Form>

		</Drawer>
		<Modal v-model="copyDataShow" title="复制广告">
			<Form ref="copyForm" :model="copyForm" :label-width="120" :rules="copyRule">
				<FormItem label="广告名称"  prop="advertName">
					<Input v-model="copyForm.advertName" placeholder="请填写广告名称" />
				</FormItem>
				<FormItem label="投放渠道"  prop="appStoreId">
					<Select v-model="copyForm.appStoreId" placeholder="请选择投放渠道">
						<Option v-for="item in appStores" :value="item.id" :key="item.id">{{item.storeName}}</Option>
					</Select>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="sureCopy">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import Vue from 'vue'
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition3'
	import TableFuncs from '../../components/statistics/TableFuncs'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams:{},
				copyDataShow: false,
				recordId: '',
				appName: this.$route.query.appName,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addStoreShow: false,
				appStores: [],
				copyDataId: '',
				copyForm: {
					advertName: '',
					appStoreId:''
				},
				copyRule: {
					advertName: [
						{ required: true, message: '请输入广告名称', trigger: 'blur' }
					],
					appStoreId: [
						{ required: true, message: '请选择投放渠道', trigger: 'blur' },
					],
				},
				addForm: {
					advertName: '',
					appStoreId: '',
					splashAdverts: [],
					tableAdverts: [],
					templateAdverts: [],
					innerAdverts: [],

					splash: {
						showNum: -1,
						intervalTime: 0,
						splashIds: [],
						adList: [],
					},

					table: {
						showNum: -1,
						intervalTime: 0,
						tableIds: [],
						adList: [],
					},

					template: [{
						id: this.util.uuid(),
						showNum: -1,
						position: '',
						templateIds: [],
						adList: [],
					}],

					inner: [{
						id: this.util.uuid(),
						showNum: -1,
						position: '',
						innerIds: [],
						adList: [],
					}],
				},
				advertCols: [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '广告名称',
						key: 'advertName',
						align: 'center'
					},
					{
						title: '优先级（小的优先展示）',
						slot: 'sortNum',
						align: 'center'
					}
				],
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '广告名称',
						key: 'advertName',
						width: 300,
						align: 'center'
					},
					{
						title: '投放渠道',
						key: 'appStoreName',
						width: 300,
						align: 'center'
					},
					{
						title: '创建日期',
						key: 'createTime',
						width: 200,
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
			this.getAllAppStore()
		},
		methods: {
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			getAllAppStore() {
				api.statistics
					.getAllUsedStores()
					.then(res => {
						this.appStores = res.data
					})
			},
			getData() {
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					appId: this.$route.query.id,
					...this.queryParams
				}
				api.statistics
					.getAppAdverts(queryParams)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据列表失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			//选择新增广告投放渠道
			chooseChannel(id) {
				console.log('------chooseChannel-------------'+id)
				if(!id){
					return
				}
				api.statistics
					.getChannelAddAppAdvertNeedInfo({ id: id })
					.then(res => {
						let adverts = res.data
						this.addForm = {
							advertName: this.addForm.advertName,
							appStoreId: id,
							splashAdverts: adverts.outAdverts.splash,
							tableAdverts: adverts.outAdverts.table,
							templateAdverts: adverts.outAdverts.template,
							innerAdverts: adverts.innerAdverts,

							splash: {
								showNum: -1,
								intervalTime: 0,
								splashIds: [],
								adList: [],
							},

							table: {
								intervalTime: 0,
								showNum: -1,
								tableIds: [],
								adList: [],
							},

							template: [{
								id: this.util.uuid(),
								showNum: -1,
								position: '',
								templateIds: [],
								adList: [],
							}],

							inner: [{
								id: this.util.uuid(),
								showNum: -1,
								position: '',
								innerIds: [],
								adList: [],
							}],
						}
					})
			},
			chooseAdvert(idArr, type, row) {
				/* console.log("------chooseAdvert----idArr--------"+idArr)
				console.log("------chooseAdvert----type--------"+type)
				console.log("------chooseAdvert----row--------"+row)
				if (this.recordId) {
					return false
				} */
				if (type == 'splash') {
					let dataArr = []
					this.addForm.splashAdverts.forEach(item => {
						if (idArr.indexOf(item.id) > -1) {
							let data={ dataId: this.util.uuid(), sortNum: 1, ...item }
							this.addForm.splash.adList.forEach(itemCheck=>{
								if(itemCheck.id==item.id){
									data.sortNum=itemCheck.sortNum
									return
								}
							})
							dataArr.push(data)
						}
					})
					this.addForm.splash.adList = dataArr
				} else if (type == 'table') {
					let dataArr = []
					this.addForm.tableAdverts.forEach(item => {
						if (idArr.indexOf(item.id) > -1) {
							let data={ dataId: this.util.uuid(), sortNum:1, ...item }
							this.addForm.table.adList.forEach(itemCheck=>{
								if(itemCheck.id==item.id){
									data.sortNum=itemCheck.sortNum
									return
								}
							})
							dataArr.push(data)
						}
					})
					this.addForm.table.adList = dataArr
				} else if (type == 'template') {
					let dataArr = []
					let adList=[]
					this.addForm.template.forEach(item => {
						if (item.id == row.id) {
							adList=item.adList
							return;
						}
					})
					this.addForm.templateAdverts.forEach(item => {
						if (idArr.indexOf(item.id) > -1) {
							let data={ dataId: this.util.uuid(), sortNum: 1, ...item }
							adList.forEach(itemCheck=>{
								if(itemCheck.id==item.id){
									data.sortNum=itemCheck.sortNum
									return
								}
							})
							dataArr.push(data)
						}
					})
					this.addForm.template.forEach(item => {
						if (item.id == row.id) {
							Vue.set(item, 'adList', dataArr)
							return;
						}
					})
				} else if (type == 'inner') {
					let dataArr = []
					let adList=[]
					this.addForm.inner.forEach(item => {
						if (item.id == row.id) {
							adList=item.adList
							return;
						}
					})
					this.addForm.innerAdverts.forEach(item => {
						if (idArr.indexOf(item.id) > -1) {
							let data={ dataId: this.util.uuid(), sortNum: 1, ...item }
							adList.forEach(itemCheck=>{
								if(itemCheck.id==item.id){
									data.sortNum=itemCheck.sortNum
									return
								}
							})
							dataArr.push(data)
						}
					})
					this.addForm.inner.forEach(item => {
						if (item.id == row.id) {
							Vue.set(item, 'adList', dataArr)
							return;
						}
					})
				}
			},
			addChildAdvert(type) {
				if (type == 'template') {
					this.addForm.template.push({
						id: this.util.uuid(),
						showNum: -1,
						position: '',
						templateIds: [],
						adList: [],
					})
				} else if (type == 'inner') {
					this.addForm.inner.push({
						id: this.util.uuid(),
						showNum: -1,
						position: '',
						innerIds: [],
						adList: [],
					})
				}
			},
			setRowData(e, row, type) {
				const val = parseInt(e.target.value)
				if (type == 'splash') {
					this.addForm.splash.adList.forEach(item => {
						if (row.dataId == item.dataId) {
							item.sortNum = val
							return
						}
					})
				} else if (type == 'table') {
					this.addForm.table.adList.forEach(item => {
						if (row.dataId == item.dataId) {
							item.sortNum = val
							return
						}
					})
				} else if (type == 'template') {
					this.addForm.template.forEach(temp => {
						temp.adList.forEach(item => {
							if (row.dataId == item.dataId) {
								item.sortNum = val
								return
							}
						})
					})
				} else if (type == 'inner') {
					this.addForm.inner.forEach(temp => {
						temp.adList.forEach(item => {
							if (row.dataId == item.dataId) {
								item.sortNum = val
								return
							}
						})
					})
				}
			},
			initAddData() {
				this.addStoreShow = false
				this.recordId = ''
				this.addForm = {
					advertName: '',
					appStoreId: '',
					splashAdverts: [],
					tableAdverts: [],
					templateAdverts: [],
					innerAdverts: [],

					splash: {
						showNum: -1,
						intervalTime: 0,
						splashIds: [],
						adList: [],
					},

					table: {
						showNum: -1,
						intervalTime: 0,
						tableIds: [],
						adList: [],
					},

					template: [{
						id: this.util.uuid(),
						showNum: -1,
						position: '',
						templateIds: [],
						adList: [],
					}],

					inner: [{
						id: this.util.uuid(),
						showNum: -1,
						position: '',
						innerIds: [],
						adList: [],
					}],
				}
			},
			addOrUpdateData() {
				const that = this
				let jsonData = {
					splash: this.addForm.splash,
					table: this.addForm.table,
					template: this.addForm.template,
					inner: this.addForm.inner,
				}
				let params = {
					id: this.recordId,
					appId: this.$route.query.id,
					advertName: this.addForm.advertName,
					appStoreId: this.addForm.appStoreId,
					jsonData: JSON.stringify(jsonData)
				}
				if (!params.advertName) {
					that.$Message.warning('请填写广告名称');
					return
				}
				if (!params.appStoreId) {
					that.$Message.warning('请选择投放渠道');
					return
				}
				api.statistics
					.addOrEditAppAdvert(params)
					.then(res => {
						that.$Message.success('Success!');
						that.refreshData()
						that.initAddData()
					})
					.catch(err => {
						that.$Message.error('新增失败: ' + err.message)
					})

			},
			updateStatus(id, status) {
				const that = this
				api.statistics
					.addOrEditAppAdvert({ 'id': id, status: status })
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			delData(id) {
				const that = this
				that.$Modal.confirm({
					title: '操作确认',
					content: '数据删除不可恢复，确定删除吗？',
					onOk: function() {
						api.statistics
							.delAppAdvert({ 'id': id })
							.then(res => {
								that.$Message.success('Success!');
								that.refreshData()
							})
					}
				})

			},
			addShow() {
				this.addStoreShow = true
			},
			editData(row) {
				this.addStoreShow = true
				this.recordId = row.id
				const data = JSON.parse(row.jsonData)
				api.statistics
					.getChannelAddAppAdvertNeedInfo({ id: row.appStoreId })
					.then(res => {
						let adverts = res.data
						this.addForm = {
							advertName: row.advertName,
							appStoreId: row.appStoreId,
							splashAdverts: adverts.outAdverts.splash,
							tableAdverts: adverts.outAdverts.table,
							templateAdverts: adverts.outAdverts.template,
							innerAdverts: adverts.innerAdverts,

							...data
						}

					})
			},
			copyData(id) {
				this.copyDataId = id
				this.copyDataShow = true
			},
			sureCopy() {
				const that=this
				api.statistics
					.copyAppAdvert({ fromAdvertId: this.copyDataId, ...this.copyForm })
					.then(res => {
						that.$Message.success('Success!');
						that.refreshData()
						that.copyDataId=''
						that.copyForm={}
					})
			}
		},	

	}
</script>
<style>
	.col {
		padding: 0 20px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.bt {
		margin-top: 50px;
		padding: 0 20px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
